import { strCode } from "../../localizations/strCode";

const deviceGroupErrors = {
  GROUP_IDS_ALREADY_EXISTS: strCode.GROUP_IDS_ALREADY_EXISTS
};

export default deviceGroupErrors;
